import React, { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { useSelector } from "react-redux";
import AlertMessage from "../components/ui/AlertMessage";
import LowStockSocket from "./LowStockSocket";
import SpeakOrderSocket from "./SpeakOrderSocket";
const fullUrl = process.env.REACT_APP_API_BASE_URL;
const baseUrl = fullUrl.replace("/api/v1", "");
// Setup socket connection
const socket = io(baseUrl, {
    transports: ["polling", "websocket"],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
});

socket.on("connect", () => {
    console.log("Connected to backend/socket, socket ID:", socket.id);
});

socket.on("connect_error", (error) => {
    console.error("Socket connection error:", error);
});

const Socket = () => {
    const [alertInfo, setAlertInfo] = useState(null);
    const userRole = useSelector((state) => state.auth.selectedRole);

    useEffect(() => {
        if (!userRole?.scopeId) return;

        if (socket.connected) {
            socket.emit("joinBranch", userRole.scopeId);
        }

        const onConnect = () => {
            socket.emit("joinBranch", userRole.scopeId);
        };

        socket.on("connect", onConnect);

        // Cleanup
        return () => {
            socket.off("connect", onConnect);
            socket.emit("leaveBranch", userRole.scopeId);
        };
    }, [userRole?.scopeId]);

    return (
        <>
            {/* Socket listener for low stock */}
            <LowStockSocket socket={socket} userRole={userRole} setAlertInfo={setAlertInfo} />
            {/*Socket listener for Order*/}
            <SpeakOrderSocket socket={socket} userRole={userRole} />

            {/* Show alert if present */}
            {alertInfo && (
                <AlertMessage
                    message={alertInfo.message}
                    variant={alertInfo.variant}
                    onClose={() => setAlertInfo(null)}
                />
            )}
        </>
    );
};

export default Socket;
